import { render, staticRenderFns } from "./all_international.vue?vue&type=template&id=5a609004&scoped=true"
import script from "./all_international.vue?vue&type=script&lang=js"
export * from "./all_international.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a609004",
  null
  
)

export default component.exports